export default "__VITE_ASSET__CqQX_Muw__"